import http from "@/utils/request"

export default {
	order: {
		list: async function (data = {}) {
			return await http.get("order/list", data);
		},
		cancel: async function (data = {}) {
			return await http.post("order/cancel", data);
		},
		train: async function (data = {}) {
			return await http.post("order/train", data);
		},
		comment: async function (data = {}) {
			return await http.post("order/comment", data);
		},
		finish: async function (data = {}) {
			return await http.post("order/finish", data);
		},
	},
	trade: {
		list: async function (data = {}) {
			return await http.get("trade/list", data);
		},
		refund: async function (data = {}) {
			return await http.post("trade/refund", data);
		},
	},
	statistics: {
		num: async function (data = {}) {
			return await http.get("statistics/num", data);
		},
		trade: async function (data = {}) {
			return await http.get("statistics/trade", data);
		},
		user: async function (data = {}) {
			return await http.get("statistics/user", data);
		},
	},
	show: {
		list1: async function (data = {}) {
			return await http.get("order/show/1", data);
		},
	},
	external: {
		list: async function (data = {}) {
			return await http.get("external/list", data);
		},
		info: async function (data = {}) {
			return await http.get("external/info", data);
		},
		audit: async function (data = {}) {
			return await http.post("external/audit", data);
		},
	}
}
